document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-description__text').forEach(function (descText) {
    if (descText.scrollHeight <= descText.clientHeight) return;

    var toggle = document.createElement('span');
    toggle.className = 'product-description__toggle';
    toggle.textContent = 'Read more';
    descText.insertAdjacentElement('afterend', toggle);

    function toggleDescription() {
      var isExpanded = descText.classList.toggle('is-expanded');
      toggle.textContent = isExpanded ? 'Read less' : 'Read more';
    }

    descText.addEventListener('click', toggleDescription);
    toggle.addEventListener('click', toggleDescription);
  });
});
